<template>
    <div>
        <van-popup position="bottom" v-model="showPopup" @click-overlay='close' :duration=".1">
            <div class="fxconfdialog_bx">
                <h2>
                    <span>订阅确认</span>
                    <i @click="close"></i>
                </h2>
                <div class="fxconfdialog_cn fxscribe-con">

                    <div class="match">
                        <div class="sai">
                            <span class="tp" :style="'color:'+ data.match.color ">{{ data.match.match_type }}</span>
                            <span class="tp">{{ data.match.start }}</span>
                            <span class="zj">专家 | <a :href="'/expert/'+data.match.expert_e" target="_blank">{{ data.match.expert }}</a></span>
                        </div>
                        <div class="duiz">
                            {{ data.match.shangpan }}<span class="pk"><i v-if="data.match.dxq">大小球</i><i v-else>让球</i><em>{{ data.match.pankou }}</em></span>{{ data.match.xiapan }}
                        </div>
                    </div>
                        <div class="item">
                            <div class="title">售价</div>
                            <div class="cont">
                                <div class="amt">
                                    <div class="sale" v-if="data.match.dian != data.match.dian0">
                                        <div class="zhekou yuan"><span>原售</span><em>{{ data.match.dian0 }}<i>FXB</i></em></div>
                                        <div class="zhekou"><span>现售</span><em>{{ dian_def }}<i>FXB</i></em></div>
                                    </div>
                                    <span class="sell" v-else>售价<em>{{ dian_def }}<i>FXB</i></em></span>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">优惠券</div>
                            <div class="cont">
                                <div class="ding">
<!--                                    <select id="couponsel" name="coupon" @change="changeCoupon" v-model="coupon_id">-->
<!--                                        <option value="0">不使用优惠券</option>-->
<!--                                        <option v-for="(c,i) in data.coupon" :key="i" :value="c.id" :disabled="c.disabled">{{c.name}}</option>-->
<!--                                    </select>-->
                                    <div @click="showCouponActionSheet" class="cpact">{{coupon_text}}</div>
                                    <router-link to="/coupon" target="_blank">领券</router-link>
                                    <van-action-sheet v-model="showCouponSheet" title="选择优惠券" cancel-text="取消" :actions="data.coupon" @select="selectCoupon"/>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">积分抵扣</div>
                            <div class="cont">
                                <span class="dikou"><em>{{ data.match.deduction }}%</em>（{{ data.match.deduction_amt }}FXB）</span>
                                <div class="jfchk">
<!--                                    <input type="checkbox" v-model="deduction_checked" :checked="deduction_checked" id="dikouchk">-->
                                    <van-checkbox v-model="deduction_checked" checked-color="#f4882a" shape="square" v-if="data.user.integral===0" disabled="disabled"/>
                                    <van-checkbox v-model="deduction_checked" checked-color="#f4882a" shape="square" v-else/>
<!--                                    <span v-if="data.user.integral===0">积分不足，无法抵扣</span>-->
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">合计</div>
                            <div class="cont">
                                <div class="total" id="txtotal"><span id="sptotal">{{ dian_rs }}</span><em>FXB</em>
                                <p v-if="coupon_amt>0 || dian_kou>0">（
                                    <template v-if="coupon_amt">优惠券<span>-{{coupon_amt}}</span></template>
                                    <template v-if="coupon_amt && dian_kou">，</template>
                                    <template v-if="dian_kou">积分<span>-{{dian_kou}}</span></template>）</p>
                                </div>
                            </div>
                        </div>
                    <div class="item curto">
                        <div class="title">余额</div>
                        <div class="cont">
                            <span id="amtyue">{{ data.user.gold }}</span><i>FXB</i>，积分 <em id="integral">{{ data.user.integral }}</em>
                            <router-link to="/account/recharge" target="_blank">充值</router-link>
                        </div>
                    </div>
                    <div class="botn">
                        <button type="button" :class="['btn', isAction?'btndis':'']" v-if="data.match.tjtype === 2" @click="submit(data.match.id)">确认订阅</button>
                        <button type="button" v-else class="btn btndis" title="不可订阅">确认订阅</button>
                        <button type="button" class="btn btncel" @click="close">取消订阅</button>
                    </div>
                    <div class="tips">该预测仅作中国体育彩票竞彩参考，请勿用于非法用途，本站倡导理性购彩。
                        订阅前请仔细阅读《<span @click="toTreaty">用户协议</span>》及《<span @click="toMianze">免责声明</span>》</div>
                </div>

            </div>
        </van-popup>


    </div>
</template>

<script>
export default {
    name: "dingyue",
    props: ['data'],
    components: {

    },
    data(){
        return {
            account: '',
            password: '',
            code: '',
            showPopup: true,

            dian_def: this.data.match.dian,  //原始金额(值不变)
            dian_dedu: this.data.match.deduction/100 * this.data.match.dian, //可抵扣金额(值不变)

            dian_kou: 0,
            dian_rs: 0, //默认支付金额
            coupon_id: this.data.coupon_id,
            coupon_amt: this.data.coupon_amt,
            coupon_text: '选择优惠券',
            deduction_checked: true,

            mid: this.data.match.mid,
            timer: null,

            showCouponSheet: false,
            isAction: false
        }
    },
    watch: {
        deduction_checked(v){
            //监听积分抵扣是否选中
            if(v === true)
                this.dian_kou = this.dian_dedu
            else
                this.dian_kou = 0
            this.setAmt()
        }
    },
    created() {

        let that = this, c = that.data.match
        that.setAmt()
        that.timer = setInterval(()=>{
            c.sytime = c.sytime-1
            if(c.sytime<=0) {
                c.tjtype = 3 //等待公开
                clearInterval(that.timer)
                that.timer = null
            }
        }, 1000)

        that.data.coupon.forEach(function (c) {
            if(c.id === that.coupon_id){
                that.coupon_text = c.name
            }
        })
    },
    methods: {
        showCouponActionSheet(){
            this.showCouponSheet = !this.showCouponSheet
        },
        selectCoupon(item){
            let that = this
            // console.log(item)
            that.coupon_amt = item.amt
            that.coupon_text = item.name
            that.coupon_id = item.id
            that.showCouponActionSheet()
            that.setAmt()
        },

        changeCoupon(e){
            let that = this
            let selectIndex = e.target.options.selectedIndex
            if(selectIndex === 0){
                that.coupon_amt = 0
            }
            else{
                selectIndex -= 1
                that.coupon_amt = that.data.coupon[selectIndex].amt
            }
            that.setAmt()
        },
        setAmt(){
            let that = this
            if(that.deduction_checked) {
                let user_integral = that.data.user.integral //用户积分

                if(user_integral>=that.dian_dedu)
                    that.dian_kou = that.dian_dedu
                else
                    that.dian_kou = user_integral
            }
            that.dian_rs = that.dian_def - that.dian_kou - that.coupon_amt
        },
        close(){
            this.$store.commit('CLOSE_DING')
        },
        toTreaty(){
          // this.close()
          // this.$router.push('/treaty')
            this.$store.commit('SHOW_TREATY')
        },
        toMianze(){
            // this.close()
            // this.$router.push('/mianze')
            this.$store.commit('SHOW_MIANZE')
        },
        submit () {
            let that = this
            // that.$store.commit('SET_DINGYUE', {'mid': that.mid, 'commend': ''})
            //
            if(that.isAction) return
            // console.log('action')
            that.isAction = true
            that.$post(that.$api.dingyue_submit, {
                amt0: that.data.user.gold,
                integral0: that.data.user.integral,
                amt: that.dian_rs,
                coupon: that.coupon_id,
                integral: that.dian_kou,
                mid: that.mid,
            }).then(function (res) {
                //console.log(res)
                if(res.code === 1) {
                    that.close()
                    let commend = res.data.commend
                    //更新预测推介内容
                    that.$store.commit('SET_DINGYUE', {'mid': that.mid, 'commend': commend})
                    //更新用户信息
                    if(res.data.user) {
                        let userInfo = JSON.parse(localStorage.getItem('user'))
                        userInfo.amt = res.data.user.amt
                        userInfo.integral = res.data.user.integral
                        that.$store.commit('SET_USER', userInfo)
                    }
                    that.$toast.success({
                        message: res.msg,
                        forbidClick: true,
                        onClose: function () {
                            //订阅成功
                            // let dingsuccess = that.$store.state.dingSuccess
                            // dingsuccess.push(that.mid)
                        }
                    })
                }
                else if(res.code === 2){
                    //余额不足
                    that.$dialog.confirm({
                        confirmButtonText: '立即充值',
                        message:res.msg,
                        title: '系统提示',

                    }).then(()=>{
                        that.$router.replace({path: '/account/recharge'})
                        that.$store.commit('CLOSE_DING')
                    }).catch(()=>{
                        that.isAction = false
                    })
                }
                else if(res.code === 3){
                    //账户有变动，重新确认
                    that.$dialog.alert({message:res.msg, title: '系统提示'})
                    // console.log(res.data)
                    if(res.data.user)
                        that.data.user = res.data.user
                    if(res.data.coupon)
                        that.data.coupon = res.data.coupon
                    if(res.data.coupon_id) {
                        that.data.coupon_id = res.data.coupon_id
                        that.coupon_id = res.data.coupon_id
                    }
                    if(res.data.coupon_amt) {
                        that.data.coupon_amt = res.data.coupon_amt
                        that.coupon_amt = res.data.coupon_amt
                    }
                    that.setAmt()
                }
                else{
                    that.$toast.fail(res.msg)
                }
            })


        },
    }
}
</script>

<style scoped>
</style>
